import React, { useContext, useState } from 'react';

import { HttpMethods, FetchContext, ApiRoutes } from '../../../../contexts';
import { useAggregatedState } from '../../../../../helpers';

export const BusinessInfoContext = React.createContext(null);

const { Provider } = BusinessInfoContext;
export const BusinessInfoProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
    });

    return (
        <Provider value={{
            state
        }}>
            {props.children}
        </Provider>
    );
}